module.exports = __webpack_public_path__ + "img/流体力学2_4_3.030ef97e.jpg";